import { LoadingButton } from "@mui/lab";
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
} from "@mui/material";
import { useSubscriptionEditPlan } from "hooks/api/useSubscriptionEditPlan";
import useNotifications from "hooks/useNotifications";
import { GlobalAppDataStorageService } from "infra/storage";
import { useEffect, useState } from "react";

export const EditPlanForm = ({
    subscriptionId,
    planId = null,
    setIsNotificationDialogOpen,
}) => {
    const [selectedPackage, setSelectedPackage] = useState("");
    const [isComponentMounted, setIsComponentMounted] = useState(true);
    const { renderErrorNotification } = useNotifications();

    const { editPlan, isLoading } = useSubscriptionEditPlan();

    const subscriptionPlans =
        GlobalAppDataStorageService.getSubscriptionPlans() ?? [];

    const packages = subscriptionPlans.flatMap((plan) => plan.packages);

    const handleChange = (event) => {
        const selectedId = event.target.value;
        const isValid = packages.some((pkg) => pkg.id === selectedId);

        if (isValid) {
            setSelectedPackage(selectedId);
        } else {
            setSelectedPackage("");
        }
    };

    useEffect(() => {
        setIsComponentMounted(true);
        return () => setIsComponentMounted(false);
    }, []);

    const handleChangePlan = async () => {
        if (selectedPackage) {
            try {
                await editPlan({ subscriptionId, packageId: selectedPackage });
                setIsNotificationDialogOpen(true);
                if (isComponentMounted) {
                    setSelectedPackage("");
                }
            } catch (error) {
                console.error("Failed to edit plan:", error);
                renderErrorNotification("Failed to edit plan");
            }
        }
    };

    return (
        <Stack direction="row" gap={2} p={2} alignItems="center">
            <FormControl size="small" sx={{ width: 250 }}>
                <InputLabel id="select-plan-label">Select plan</InputLabel>
                <Select
                    labelId="select-plan-label"
                    id="select-plan"
                    value={selectedPackage}
                    onChange={handleChange}
                    label="Select plan"
                    displayEmpty
                >
                    {packages.map((pkg) => (
                        <MenuItem
                            key={pkg.id}
                            value={pkg.id}
                            disabled={pkg.id === planId}
                        >
                            {pkg.name} {pkg.id === planId && "(current)"}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <LoadingButton
                size="small"
                loading={isLoading}
                onClick={handleChangePlan}
                disabled={!selectedPackage}
                variant="contained"
            >
                Change Plan
            </LoadingButton>
        </Stack>
    );
};

export default EditPlanForm;
